import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-bl.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationBlConstants } from "./create-application-location-bl.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { debounceTime } from "rxjs";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let CreateApplicationLocationBlComponent = class CreateApplicationLocationBlComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    modalService;
    aflaModuleStrategyService;
    recipientListService;
    appController;
    mapService;
    requestStatusService;
    changeDetectorRefs;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationBlConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationBlConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationBlConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = CreateApplicationLocationBlConstants.DESCRIPTION_LABEL_4;
    validationMessages = CreateApplicationLocationBlConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationBlConstants.ERF_NO_CONTROL;
    subdivisionControl = CreateApplicationLocationBlConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationBlConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationBlConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationBlConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationBlConstants.ADDRESS_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationBlConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationBlConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationBlConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationBlConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationBlConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationBlConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = CreateApplicationLocationBlConstants.OWNER_LABEL;
    copyApplicantToOwnerLabel = CreateApplicationLocationBlConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = CreateApplicationLocationBlConstants.REMOVE_PROPERTY_LABEL;
    unitNumberControl = CreateApplicationLocationBlConstants.UNIT_NUMBER_CONTROL;
    shopNumberControl = CreateApplicationLocationBlConstants.SHOP_NUMBER_CONTROL;
    titleDeedNumberControl = CreateApplicationLocationBlConstants.TITLE_DEED_NUMBER_CONTROL;
    titleDeedDescriptionControl = CreateApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_CONTROL;
    accommodationNameControl = CreateApplicationLocationBlConstants.ACCOMMODATION_NAME_CONTROL;
    unitNumberLabel = CreateApplicationLocationBlConstants.UNIT_NUMBER_LABEL;
    shopNumberLabel = CreateApplicationLocationBlConstants.SHOP_NUMBER_LABEL;
    titleDeedNumberLabel = CreateApplicationLocationBlConstants.TITLE_DEED_NUMBER_LABEL;
    titleDeedDescriptionLabel = CreateApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_LABEL;
    accommodationNameLabel = CreateApplicationLocationBlConstants.ACCOMMODATION_NAME_LABEL;
    onlyOnePropert = CreateApplicationLocationBlConstants.ONLY_ONE_PROPERTY_ALLOWED;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owner";
    mapComponent;
    isMapLoaded = false;
    modalOptions = CreateApplicationLocationBlConstants.MODAL_OPTION;
    selectedPropertySubscription;
    getTrueCentroidSubscription;
    clearLayerGraphicsSubjectSubscription;
    constructor(createApplicationService, modalService, aflaModuleStrategyService, recipientListService, appController, mapService, requestStatusService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.modalService = modalService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
        if (this.createApplicationService.propertyData) {
            this.loadExistingProperty(this.createApplicationService.propertyData);
            this.createApplicationService.propertyData = null;
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    ngOnDestroy() {
        this.startMetadataSubscription.unsubscribe();
        this.mapService.actionPropertyEnabled = false;
    }
    loadMetadata(stepMeta) {
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        const sgCodeControl = propertyControl.get(this.sgCodeControl);
        if (sgCodeControl.value !== null && sgCodeControl.value !== undefined && sgCodeControl.value !== "") {
            sgCodeControl.disable();
        }
        else {
            sgCodeControl.enable();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    // public onBtnCopyApplicantToOwnerClicked(propertyIndex: number): void {
    //   const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
    //   const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
    //   this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
    //   this.changeDetectorRefs.detectChanges();
    // }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationBlConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        // TODO: build a lookup map for mapping the propertyData layer to the data for Property
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                unitNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "UnitNumber", "unitnumber")),
                shopNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ShopNumber", "shopnumber")),
                titleDeedNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeedNumber", "titledeednumber"), [Validators.required]),
                titleDeedDescription: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "TitleDeedDescription", "titledeeddescription:"), [Validators.required]),
                accommodationName: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "AccommodationName", "accommodationname")),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroidSubscription = this.createApplicationService.getTrueCentroid(url, formData)
                .pipe(takeUntil(this._destroy$), take(1)).subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.handleAddProperty(newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(CreateApplicationLocationBlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    handleAddProperty(newProperty) {
        const propertyControl = this.getProperties();
        if (this.getProperties().controls.length > 0) {
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
            this.appController.showMessage(CreateApplicationLocationBlConstants.ONLY_ONE_PROPERTY_ALLOWED, AlertType.Warning);
            return;
        }
        propertyControl.push(newProperty);
        this.active = 0;
        this.updateRequiredFields(0);
        this.changeDetectorRefs.detectChanges();
        this.syncMapGeometries();
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Business licence graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).pipe(takeUntil(this._destroy$), take(1)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Business licence graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: NgbModal },
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationBlComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-location-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], CreateApplicationLocationBlComponent);
export { CreateApplicationLocationBlComponent };
